import { Component, ElementRef, signal, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RegisterModal } from "./components/register-modal/register-modal";
import { LoginForm } from "./components/login-form/login-form";
import { RecoverForm } from "./components/recover-form/recover-form";
import { EnterCodeForm } from "./components/enter-code-form/enter-code-form";
import { ResetPasswordForm } from "./components/reset-password-form/reset-password-form";
import { buildVersion } from '../../../environments/version';

type ViewMode = 'login' | 'recover' | 'enter-code' | 'reset-password';

@Component({
  selector: 'app-login',
  imports: [FormsModule, RegisterModal, LoginForm, RecoverForm, EnterCodeForm, ResetPasswordForm],
  templateUrl: './login.html',
  styleUrl: './login.scss',
})
export class Login {
  version = buildVersion;
  viewMode = signal<ViewMode>('login');
  recoveryEmail = signal('');
  resetToken = signal('');
  isMuted = signal(true);
  isPlaying = signal(true);

  @ViewChild('bgVideo', { static: false })
  videoRef!: ElementRef<HTMLVideoElement>;
  private playlist = [
    { src: 'video/promo.mp4', loop: false },
    { src: 'video/loop.mp4', loop: true }
  ];
  private videoIndex = 0;

  ngAfterViewInit(): void {
    const video = this.videoRef.nativeElement;

    video.addEventListener('ended', () => {
      this.videoIndex++;
      this.playCurrent(video);
    });

    this.playCurrent(video);
  }

  private playCurrent(video: HTMLVideoElement) {
    const item = this.playlist[this.videoIndex];

    console.log("Preparing to play video.");
    video.src = item.src;
    video.loop = item.loop;

    video.load();   // important for Safari
    video.muted = true;
    video.play().then(() => {
      this.isPlaying.set(true);
    }).catch((error) => {
      console.log("Something happened.", error);
      this.isPlaying.set(false);
      // autoplay fallback if needed
    });
  }

  handleCodeVerified(code: string) {
    this.resetToken.set(code);
    this.setView('reset-password');
  }

  handlePasswordReset() {
    this.recoveryEmail.set('');
    this.resetToken.set('');
    this.setView('login');
  }

  setView(mode: ViewMode) {
    this.viewMode.set(mode);
    setTimeout(() => {
      const heading = document.querySelector('.form-view-container h2') as HTMLElement;
      if (heading) {
        heading.setAttribute('tabindex', '-1');
        heading.focus();
      }
    }, 50);
  }

  toggleMute() {
    this.isMuted.update(muted => !muted);
  }

  togglePlay() {
    const video = this.videoRef?.nativeElement;
    if (!video) return;

    if (video.paused) {
      video.play().then(() => {
        this.isPlaying.set(true);
      }).catch(err => console.log('Could not play video:', err));
    } else {
      video.pause();
      this.isPlaying.set(false);
    }
  }
}
